// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// ─── Yükleniyor ekranı ────────────────────────────────────────────────────────
function LoadingScreen() {
  return (
    <div style={{
      minHeight: "100vh", background: "#0d0a05",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <style>{`
        @keyframes bcPulse { 0%,100%{opacity:0.3} 50%{opacity:1} }
      `}</style>
      <span style={{
        fontFamily: "'Courier Prime', monospace",
        color: "rgba(212,168,83,0.6)", letterSpacing: "0.3em",
        fontSize: 12, textTransform: "uppercase",
        animation: "bcPulse 1.5s ease-in-out infinite",
      }}>✦ Yükleniyor ✦</span>
    </div>
  );
}

// ─── ProtectedRoute ───────────────────────────────────────────────────────────
// Kullanım:
//   <Route path="/music" element={<ProtectedRoute><MusicCompile /></ProtectedRoute>} />
//   <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
//
export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  // Firebase henüz cevap vermedi — bekle
  if (loading) return <LoadingScreen />;

  // Giriş yapılmamış → /auth sayfasına yönlendir, geri dönüş adresini sakla
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Admin yetkisi gerekiyor ama kullanıcı admin değil → ana sayfaya
  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
